import React, { useState} from "react"
import './styles/CreateTaskForm.css';

const CreateTaskForm = ({createTask}) => {
    const [taskName, setTaskName] = useState("")
    
    const onSubmit = (e) => {
        e.preventDefault()
        if (!taskName) {
            alert("Please provide a task name.")
            return
        }
        createTask(taskName)
    }

    return (
        <form onSubmit={onSubmit} className="create-task-form">
            <input 
            type = 'text'
            placeholder='Task Name'
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
            />
            <input 
            type='submit' 
            value='create task' 
            className = 'btn'
            id = 'create-task-btn'
            />
        </form>
    )
}

export default CreateTaskForm
